export default __webpack_public_path__ + "static/media/cover.7e7699bb.jpg";